import { z } from 'zod';
import { emailSchema } from '../auth/email.js';
import { passwordSchema } from '../auth/password.js';

export const createInstitutionUserSchema = z.object({
  first_name: z.string().min(1, 'First name is required'),
  last_name: z.string().min(1, 'Last name is required'),
  email: emailSchema('Valid email is required'),
  phone: z.string().optional(),
  password: passwordSchema,
});

export type CreateInstitutionUserPayload = z.infer<typeof createInstitutionUserSchema>;
